import { render, staticRenderFns } from "./FormSpinbuttonSlots.vue?vue&type=template&id=73c20c5e&"
import script from "./FormSpinbuttonSlots.vue?vue&type=script&lang=js&"
export * from "./FormSpinbuttonSlots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports